import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { BASE_PROJECT_PATH, generateRoutePath } from '@/src/routes';

import { ResponseSubtaskReportDto } from '../types';

const url = `${PREFIX_URL}${BASE_PROJECT_PATH}/getDashboardReports`;

export type SubtaskReportsResponse = {
  reports: ResponseSubtaskReportDto[];
};

export const getSubtaskReports = (params): Promise<SubtaskReportsResponse> => {
  return axios.get(generateRoutePath(url, { projectId: params.projectId }), {
    params,
    showError: false,
  });
};

export const subtaskReportsKeys = {
  list: ['subtaskReportsList'] as const,
};

type QueryFnType = typeof getSubtaskReports;

type useSubtaskReportsOptions = {
  projectId: string;
  from: string;
  to: string;
  config?: QueryConfig<QueryFnType>;
};

export const useSubtaskReports = ({
  projectId,
  config,
  ...otherParams
}: useSubtaskReportsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [...subtaskReportsKeys.list, projectId, otherParams],
    queryFn: () => getSubtaskReports({ projectId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
